module.exports = __webpack_public_path__ + "img/pz.54dfbe0e.jpg";